// extracted by mini-css-extract-plugin
module.exports = {"searchMenu":"JU","itemCount":"KU","filters":"LU"};